import React, { useContext, useEffect, useState } from 'react'
import Timeline from './Timeline'
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    ButtonGroup,
} from "@material-tailwind/react";
import SubtitleDiv from './SubtitleDiv';
import { addcontext } from '../../ContextShare/ContextShare';
import RelatedMembers from './RelatedMembers';
import CompressD from './CompressD';
import { Icon } from '@iconify/react';
import TagOfVideo from './TagOfVideo';
import { updateDownCount, updateDownCountBS, updateDownCountGA, updateDownCountRL } from '../../Services/allApi';
import { toast } from 'react-toastify';
import language from '../../language.json'

function DescriptionNew() {
    const { videoData, setVideoData } = useContext(addcontext)
    const { whichPageIsSendingData, setwhichPageIsSendingData } = useContext(addcontext)
    const [isSeeMore, setSeeMore] = useState(false)
    const [isActionOpen, setActionOpen] = useState(false)
    const [isTimelineOpen, setisTimelineOpen] = useState(false)
    const [isCompressOpen, setisCompressOpen] = useState(false)
    const [isSubOpen, setSubOpen] = useState(false)
    const [scrnshot, setscrnshot] = useState()
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState();
    const {langChanged,setlangChanged}=useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();
  
    useEffect(()=>{
        setCurrentLanguage(localStorage.getItem('language')||'en')
  },[currentLanguage,langChanged])
    // const handleSeeMore = () => {

    //     setSeeMore(!isSeeMore); // Toggle the value of isSeeMore
    //     setrelatedMembers(isSeeMore ? [1, 2, 3] : [1, 2, 3, 4, 5]);

    // }

    const handleTimelineOpen = () => {
        setisTimelineOpen(!isTimelineOpen)
        setSubOpen(false)
        setisCompressOpen(false)
    }

    // is share option open
    const handleSubtitleOpen = () => {
        setSubOpen(!isSubOpen)
        setisTimelineOpen(false)
        setisCompressOpen(false)
    }

    const handleOpen = () => setOpen(!open);

    const handleUploadScreenshot = (e) => {
        // Your logic for handling file upload
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        // Assuming you have an image element with an ID of 'screenshotImage'
        const imgElement = document.getElementById('screenshotImage');

        // Update the image source when a file is selected
        if (imgElement && selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                imgElement.src = e.target.result;
            };
            reader.revideoDataadAsDataURL(selectedFile);
        }
    };

    const handleCloseModal = () => {
        setOpen(!open)
        setFile(null)
    }
    // open compression box
    const handleCompressOpen=()=>{
        setisCompressOpen(!isCompressOpen)
        // setSubOpen(false)
        setisTimelineOpen(false)
        setSubOpen(false)
    }
    
    // update download count
    const handleDownloadVideo=async()=>{
        try{
                const result=await updateDownCount(videoData?.mapping_id)
                // console.log(result);     
          }catch(error){
            toast.error('There was an error')
          }
         
    }

    // Add other sharing URLs as needed
    return (
        <div className='flex flex-col w-full h-full'>

            {/* action button */}
            <div className='w-full flex md:justify-center justify-start md:pl-0 pl-5'>
                <div className='md:w-9/12 w-full flex flex-row'><button onClick={() => setActionOpen(!isActionOpen)} className='md:w-2/12 w-6/12 rounded-lg text-white h-10 bg-primary transition duration-300 ease-in-out'>{language.Actions[currentLanguage]}
                    {!isActionOpen ?
                        <i class="fa-solid fa-chevron-down ms-2"></i>
                        :
                        <i class="fa-solid fa-chevron-up ms-2"></i>}
                </button>
                </div>
            </div>

            {/* 4 buttons */}
            {isActionOpen &&
                <div className='w-full flex md:justify-center justify-start  '>

                    <div className='md:w-9/12 w-full flex lg:flex-row flex-col justify-between'>

                        <div className={`${currentLanguage=='mal'&&'text-xs'} md:text-lg text-xs xl:w-2/12 lg:w-3/12 w-6/12 flex flex-col h-40 gap-2 justify-center bg-success shadow-lg mt-5 border border-blue-gray-800 rounded md:ms-0 ms-5`}>

                            <div className=' flex flex-row hover:text-white hover:bg-primary h-10 items-center cursor-pointer'>
                                <div className='ms-5'><i class="fa-solid fa-download me-2"></i>
                                    <a target='_blank' className='md:text-sm text-xs' href={videoData?.video_url} onClick={handleDownloadVideo} download>{language.Download_Original[currentLanguage]}</a></div>
                            </div>

                            <div onClick={handleCompressOpen} className={isCompressOpen ? 'flex flex-row text-white bg-primary h-10 items-center cursor-pointer' : 'flex flex-row hover:text-white hover:bg-primary h-10 items-center cursor-pointer'} >
                                <div className='ms-5 flex flex-row w-full items-center md:text-sm text-xs'>
                                    {/* <i class="fa-solid fa-timeline me-2 mt-1"></i> */}
                                    <Icon icon="ic:twotone-downloading" className='me-2 text-lg font-bold' />
                                    {language.Compress_Download[currentLanguage]}
                                    {/* {isCompressOpen && <div className='flex w-full justify-end '><i class="fa-solid fa-xmark me-2 mt-1 hover:text-red-400"></i></div>} */}

                                </div>
                            </div>

                            {/* <div onClick={handleTimelineOpen} className={isTimelineOpen ? 'flex flex-row text-white bg-primary h-10 items-center cursor-pointer' : 'flex flex-row hover:text-white hover:bg-primary h-10 items-center cursor-pointer'} >
                                <div className='ms-5 flex flex-row w-full items-center'><i class="fa-solid fa-timeline me-2"></i>
                                {language.Timeline[currentLanguage]}
                                    {isTimelineOpen && <div className='flex w-full justify-end '><i class="fa-solid fa-xmark me-2 hover:text-red-400"></i></div>}

                                </div>
                            </div> */}

                            <div onClick={handleSubtitleOpen} className={isSubOpen ? 'flex flex-row text-white bg-primary h-10 items-center cursor-pointer' : 'flex flex-row hover:text-white hover:bg-primary h-10 items-center cursor-pointer'} >
                                <div className='ms-5 flex flex-row w-full items-center md:text-sm text-xs'><i class="fa-solid fa-share-nodes me-2"></i>

                                {language.Share[currentLanguage]}
                                    {/* {isSubOpen && <div className='flex w-full justify-end '><i class="fa-solid fa-xmark me-2 hover:text-red-400"></i></div>} */}

                                </div>
                            </div>


                            {/* <div onClick={handleSubtitleOpen} className={isSubOpen?'flex flex-row text-white bg-primary h-12 items-center cursor-pointer':'cursor-pointer flex flex-row hover:text-white hover:bg-primary h-12 items-center'}>
                                <div className='ms-5 flex flex-row w-full'><i class="fa-regular fa-closed-captioning me-2 mt-1"></i>
                                Subtitle
                                    {isSubOpen&&<div className='flex w-full justify-end '><i class="fa-solid fa-xmark me-2 mt-1 hover:text-red-400"></i></div>}
                                    
                                    </div>
                            </div> */}

                            {/* <div onClick={handleOpen} className='flex flex-row text-red-700 hover:text-white hover:bg-red-700 h-12 items-center cursor-pointer'>
                                <div className='ms-5'><i class="fa-solid fa-circle-exclamation me-2"></i>
                                    Report issue</div>
                            </div> */}

                        </div>

                        {isTimelineOpen && <div className='w-9/12 mt-5'>
                            <Timeline />
                        </div>
                        }

                        {isCompressOpen && <div className='lg:w-9/12 md:8/12 w-full mt-5'>
                            <CompressD videoId={videoData?.video_id} />
                        </div>
                        }

                        {
                            isSubOpen&& <div className='w-9/12 mt-5'>
                                <SubtitleDiv videoData={videoData} />
                            </div>
                        }

                    </div>
                </div>}


            <div className='flex justify-center ' style={{ height: '100%', width: '100%' }}>
                <div className='lg:w-9/12 w-full flex lg:flex-row flex-col mt-5 max-h-96'>
                    {/* Description */}
                    <div className='flex flex-col lg:w-9/12 w-full '>
                        <div className='lg:text-left text-center'><h2 className='text-xl font-semibold'>{whichPageIsSendingData == 'govaddress' ? videoData?.address_title : whichPageIsSendingData == 'budgetspeech' ? videoData?.speech_title : whichPageIsSendingData == 'rulings' ? videoData?.rulings_title : videoData?.video_title}</h2></div>
                        {/* <div className='lg:w-10/12 w-11/12 lg:text-left text-center '>
                        <p className='mt-6 lg:ms-0 ms-8'>
                            {whichPageIsSendingData == 'govaddress' ? videoData?.address_subject : whichPageIsSendingData == 'budgetspeech' ? videoData?.speech_subject : whichPageIsSendingData == 'rulings' ? videoData?.rulings_subject : videoData?.video_subject}
                        </p></div> */}
                        <div className='mt-6 flex flex-row w-full pr-5  lg:pl-0 pl-5 gap-16 justify-start lg:text-left text-left ' style={{ color: '#606060' }}>
                            <div className='flex flex-col md:text-lg text-sm md:w-2/12 w-4/12 ' >
                                <p >{language.kla[currentLanguage]}:</p>
                                <p className='mt-5'>{language.Session[currentLanguage]}:</p>
                                <p className='mt-5'>{language.Event_single[currentLanguage]}:</p>
                                <p className='mt-5'>{language.Sitting_Date[currentLanguage]}:</p>
                                <p className='mt-5'>{language.Subject[currentLanguage]}:</p>
                                {/* <p className='mt-5'>{whichPageIsSendingData == 'govaddress' ? 'Governer' : whichPageIsSendingData == 'rulings' ? 'Speaker' : whichPageIsSendingData == 'budgetspeech' ? 'Minister' : 'Member'}</p> */}
                                {/* <p className='mt-5'>Views Count</p> */}
                            </div>

                            <div className='flex flex-col md:text-lg text-sm w-full h-full overflow-hidden'>
                                <p className='text-sm md:text-lg'>{videoData?.kla}</p>
                                <p className='mt-5 text-sm md:text-lg'>{whichPageIsSendingData == 'govaddress' ? videoData?.session : whichPageIsSendingData == 'budgetspeech' ? videoData?.speech_session : whichPageIsSendingData == 'rulings' ? videoData?.rulings_session : videoData?.video_session}</p>

                                <p className='mt-5 text-sm md:text-lg'>{currentLanguage=='en'?videoData?.video_event:videoData?.malayalam_video_event||"----"}</p>
                                <p className='mt-5 text-sm md:text-lg'>{whichPageIsSendingData == 'govaddress' ? videoData?.address_date.slice(0, 10) : whichPageIsSendingData == 'budgetspeech' ? videoData?.speech_date.slice(0, 10) : whichPageIsSendingData == 'rulings' ? videoData?.rulings_date.slice(0, 10) : videoData?.video_upload_date}</p>
                                <p className='mt-5 text-sm md:text-lg text-justify'>{currentLanguage=='en'?videoData?.video_subject:videoData?.mal_video_subject||"----"}</p>


                                {/* <p className='mt-5'>{whichPageIsSendingData == 'govaddress' ? videoData?.address_member : whichPageIsSendingData == 'budgetspeech' ? videoData?.speech_member : whichPageIsSendingData == 'rulings' ? videoData?.rulings_member : videoData?.video_member}</p> */}

                            </div>
                        </div>



                    </div>

                    {/* Related members */}
                    <RelatedMembers videoData={videoData}/>

                </div>


            </div>

            <div className='w-full h-full justify-center flex'>
                <div className='lg:w-9/12 w-10/12 flex justify-center mb-5 mt-5'>
                <TagOfVideo videoData={videoData}/>
                </div>
            </div>
 
            <div className='w-full h-full justify-center flex'>
                <div className='lg:w-9/12 w-10/12 h-1 bg-primary flex justify-center mb-2 '></div>
            </div>





        </div >
    )
}

export default DescriptionNew